<template>
	<div class="agreement" v-loading="loading">
		 <!-- {{ detials }} -->
		<div v-html="detials.content"></div>
	</div>
</template>
<script>
	 
 
	export default {
		components: {
			 
		},
		name: "index",
		data() {
			return {
				detials:{},
			}
		},
		computed: {
			 
		},
		watch: {
			 
		},
		created() {
            this.get_detial()
		},
		methods: {
            get_detial(){
                this.loading=true
                this.$api("getArticle", {
                    id:this.$route.query.id,
                }, "get").then((res) => {
                    this.loading = false
                    console.log('新闻详情1',res)
					this.loading=false
                    if (res.code == 1) {
                        this.detials=res.data
                    } else {
                        alertErr(res.msg)
                    }
                });
            },
		 
			 



		},

	}
</script>
<style scoped lang="less">
	.agreement {
		width: 100%;
		height: 100vh;
		padding:32px;
		 

	}
</style>